// Gestes de l'écran des add-ons, communs à la 14e et à Séance (fichier identique
// dans les deux lecteurs). Sans DOM réel : `essais/addons-ecran.mjs` les éprouve.

/** Case activer/désactiver : un refus remet la case et dit pourquoi, sinon elle ment. */
export function brancherCases(cible, { api, signaler }) {
  for (const el of cible.querySelectorAll('[data-actif]')) {
    el.onchange = async () => {
      try {
        await api(`/api/admin/sources/${el.dataset.actif}`, {
          method: 'PUT',
          body: JSON.stringify({ enabled: el.checked }),
        });
      } catch (err) {
        el.checked = !el.checked;
        signaler(el.dataset.actif, err.message);
      }
    };
  }
}

/** Bouton ✕ : confirmation (sans retour), DELETE, puis la liste se relit. */
export function brancherRetraits(cible, { api, confirmer, recharger, signaler, nomDe }) {
  for (const el of cible.querySelectorAll('[data-retirer]')) {
    el.onclick = async () => {
      const id = el.dataset.retirer;
      if (!confirmer(`Retirer « ${nomDe(id) ?? 'cet add-on'} » ?`)) return;
      try {
        await api(`/api/admin/sources/${id}`, { method: 'DELETE' });
        recharger();
      } catch (err) {
        signaler(id, err.message);
      }
    };
  }
}
